import { useNavigate } from "react-router-dom";
import { useState, forwardRef } from "react";
import { useAuth } from "../../../context/LoginContext/AuthContext";
import { useAuthStudent } from "../../../context/StudentLoginContext/StudentAuthContext";
import { AuthModal } from "../../../common/AuthV2/AuthModal";
import Avatar from "react-avatar";
import { authNavigator } from "../../../../utils/authNavigator";
import { Dropdown } from "react-bootstrap";
import LogoutModal from "../../../common/LogoutModal";
import { getSubdomain } from "../../../../utils/subdomian";

const CustomToggle = forwardRef(({ children, onClick }, ref) => (
  <div
    ref={ref}
    className="homeNavbar__user"
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
    style={{ cursor: "pointer", border: "none", background: "transparent" }}
  >
    {children}
  </div>
));

const NavbarLogin = ({ showProfileDropdown = true }) => {
  const navigate = useNavigate();
  const subdomain = getSubdomain();
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [authModalView, setAuthModalView] = useState("options");
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [logoutState, setLogoutState] = useState({
    loading: false,
    success: false,
    error: "",
  });
  const { user, logout } = useAuth();
  const { student, clearStoredData } = useAuthStudent();

  const handleLoginClick = () => {
    if (subdomain) {
      navigate("/login");
    } else {
      setAuthModalView("options");
      setShowAuthModal(true);
    }
  };

  const handleSignUpClick = () => {
    if (subdomain) {
      navigate("/login");
    } else {
      setAuthModalView("register");
      setShowAuthModal(true);
    }
  };

  const handleMobileAuthClick = () => {
    if (subdomain) {
      navigate("/login");
    } else {
      setAuthModalView("options");
      setShowAuthModal(true);
    }
  };

  const handleRedirection = () => {
    authNavigator({
      user: user?.user || student?.student,
      redirect: "",
      tab: "",
      navigate,
    });
  };

  const handleLogout = async () => {
    setLogoutState({ loading: true, success: false, error: "" });
    try {
      await logout();
      setLogoutState({ loading: false, success: true, error: "" });
      clearStoredData();
    } catch (err) {
      setLogoutState({
        loading: false,
        success: false,
        error: err.message || "Failed to logout",
      });
    }
  };

  const handleCloseModal = () => {
    setShowLogoutModal(false);
    setLogoutState({ loading: false, success: false, error: "" });
  };

  const displayName =
    user?.user?.firstName || user?.firstName || student?.student?.name;

  return (
    <div>
      {!displayName || displayName == null ? (
        <>
          {/* Desktop buttons */}

          <div className="homeNavbar__actions">
            <button
              className="homeNavbar__btn homeNavbar__btn--login"
              id="home-navbar-login-btn"
              onClick={handleLoginClick}
            >
              Log in
            </button>
            {!subdomain && (
              <button
                className="homeNavbar__btn homeNavbar__btn--signup"
                id="home-navbar-signup-btn"
                onClick={handleSignUpClick}
              >
                Sign up
              </button>
            )}
          </div>
          {/* Mobile button */}
          <button
            className="homeNavbar__mobileBtn"
            id="home-navbar-mobile-btn"
            onClick={handleMobileAuthClick}
          >
            {subdomain ? "Log in" : "Login / Sign Up"}
          </button>
        </>
      ) : showProfileDropdown ? (
        /* Logged-in user dropdown */
        <Dropdown align="end">
          <Dropdown.Toggle as={CustomToggle} id="profile-dropdown">
            <span>Hi {displayName}</span>
            <Avatar name={displayName} color="#0a1b6b" round="20px" size="35" />
          </Dropdown.Toggle>

          <Dropdown.Menu
            className="profile-dropdown-menu shadow border-0 mt-2"
            style={{ minWidth: "220px" }}
          >
            <div className="dropdown-user-info px-3 py-2">
              <div className="fw-bold">{displayName}</div>
              <div
                className="text-muted small text-truncate"
                title={user?.user?.email || student?.student?.username}
              >
                {user?.user?.email || student?.student?.username}
              </div>
            </div>
            <Dropdown.Divider />
            <Dropdown.Item onClick={handleRedirection}>
              <i className="bi bi-speedometer2 me-2"></i>
              Dashboard
            </Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item
              onClick={() => setShowLogoutModal(true)}
              className="text-danger"
            >
              <i className="bi bi-box-arrow-right me-2"></i>
              Logout
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      ) : (
        /* Logged-in user avatar only */
        <div
          className="homeNavbar__user"
          id="home-navbar-user"
          onClick={handleRedirection}
          style={{ cursor: "pointer" }}
        >
          <span>Hi {displayName}</span>
          <Avatar name={displayName} color="#0a1b6b" round="20px" size="35" />
        </div>
      )}

      <AuthModal
        show={showAuthModal}
        onHide={() => setShowAuthModal(false)}
        defaultView={authModalView}
      />

      <LogoutModal
        showModal={showLogoutModal}
        handleClose={handleCloseModal}
        onLogout={handleLogout}
        loading={logoutState.loading}
        success={logoutState.success}
        error={logoutState.error}
        redirectPath="/"
      />
    </div>
  );
};
export default NavbarLogin;
